export const SCHOOL_CLASS_NAMES = {
  CLASS_8_REVIEW: "Powtórka do E8",
  CLASS_8: "8 klasa",
  CLASS_7: "7 klasa",
} as const;

export type SchoolClassName = (typeof SCHOOL_CLASS_NAMES)[keyof typeof SCHOOL_CLASS_NAMES];
